import React from 'react';
import Preloader from './UI/Preloader';
import CollectionCard from "./CollectionCard";

const CollectionList = ({collections, isLoading}) => {

    return (
        <div className="container">
        {
            !isLoading && !collections.length && <p className="advert-list__empty-state">Здесь пока нет коллекций</p>
        }
        {
            isLoading && <Preloader/>
        }
        {collections && (
            <div className="collection-list">
                    {collections.map((collection) => (
                        <CollectionCard collection={collection}/>
                    ))}
                </div>
        )}
    </div>
    )
};

export default CollectionList;
